import React from "react";

const BE18Dashboard = () => <div>BE18 Dashboard</div>;

export default BE18Dashboard;